'use strict';

const React = require('react'),
  { t } = require('services/i18nextWrapper'),
  { delay } = require('lodash/function'),
  DateUtils = require('utils/DateUtils'),
  NumberUtils = require('utils/NumberUtils'),
  NavigationUtils = require('utils/NavigationUtils'),
  { map, find, reduce } = require('lodash/collection'),
  SessionStore = require('stores/SessionStore'),
  FlatSphere = require('components/Commons/FlatSphere/FlatSphere'),
  LocaleUtils = require('utils/LocaleUtils'),
  Notification = require('components/Notification/Notification'),
  AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
  AdminScaffoldingTablePaged = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTablePaged'),
  AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
  FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
  Loading = require('components/Commons/Loading/Loading'),
  ContentUtils = require('utils/ContentUtils'),
  CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
  AppConstants = require('constants/AppConstants'),
  InventoryStore = require('stores/InventoryStore'),
  FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
  FormGroupDatePicker = require('components/Commons/BasicForm/FormGroupDatePicker/FormGroupDatePicker'),
  FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
  FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
  Authentication = require('services/Security').Authentication,
  ga = require('react-ga'),
  { Navigation } = require('react-router'),
  get = require('lodash/object').get;

const pageUrl = '/sales/page/';

const INITIAL_STATE = {
  selectedItem: null,
  selectedCustomer: null,
  selectedShippingTo: null,
  selectedBillingTo: null,
  isEditMode: false,
  isFetching: true,
  amountPaid: null,
  filter: Object.freeze({
    code: '',
    customerName: '',
    state: '',
    displayDateOpen: '',
    displayDeliveredDate: '',
    displayPriority: '',
    amountPaid: '',
    totalPriceWithUnit: ''
  })
};

const SalesAdmin = React.createClass({displayName: "SalesAdmin",

  mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

  getInitialState() {
    return INITIAL_STATE;
  },

  componentDidMount() {
    this.fetchItems();
    ga.pageview('/sales-admin');
  },

  fetchItems() {
    const self = this;
    const currentPage = NavigationUtils.getPathParam('page');
    InventoryStore.fetchSales(currentPage, function (sales) {
      InventoryStore.fetchCustomers(function (customers) {
        self.setState({
          sales: self._sortSalesOrder(
            self._hydrateAdditionalInfo(
              ContentUtils.filterEnable(sales)
            )
          ),
          isFetching: false,
          customers: ContentUtils.filterEnable(customers)
        });
      });
    });
  },

  fetchItemsBy(filter) {
    const self = this;
    InventoryStore.fetchSalesBy(filter, function (sales) {
      InventoryStore.fetchCustomers(function (customers) {
        self.setState({
          sales: self._sortSalesOrder(
            self._hydrateAdditionalInfo(
              ContentUtils.filterEnable(sales)
            )
          ),
          isFetching: false,
          customers: ContentUtils.filterEnable(customers)
        });
      });
    });
  },

  _onClickPage(page) {
    this.transitionTo('/sales/page/:page', { page });
    this.fetchItems();
  },

  _sortSalesOrder(sales) {
    return DateUtils.sortListByDateFieldDesc(sales, 'dateCreated');
  },

  _hydrateAdditionalInfo(sales) {
    return map(sales, sale => {
      sale.displayDateOpen = DateUtils.toCurrentTimeZone(
        sale.dateCreated,
        SessionStore.getCurrentTimeZone()
      );
      sale.displayDeliveredDate = DateUtils.toCurrentTimeZone(
        sale.deliveredDate,
        SessionStore.getCurrentTimeZone()
      );

      const saleItems = get(sale, 'items') || [];
      const saleItemsPrices = map(saleItems, saleItem => {
        const priceByUnit = NumberUtils.formatDecimal(get(saleItem, 'customPriceUnit'),get(SessionStore.getCurrentCurrencyDigits(), 'value'));
        const amount = get(saleItem, 'amount') || 1;
        return NumberUtils.multiplyAndTruncate(priceByUnit, amount);
      });
      sale.totalPrice = reduce(saleItemsPrices, (total, itemPrice) => {
        return NumberUtils.sum(total, itemPrice);
      });
      sale.totalPriceWithUnit = `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(sale.totalSalePrice,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}`;
      sale.amountPaid = sale.sale.amountPaid > 0 ? `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(sale.sale.amountPaid,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}` : `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(sale.totalSalePrice,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}`;
      
      return sale;
    });
  },

  onDeleteSale(saleId, onSuccess, onFailure) {
    const sales = get(this.state, 'sales') || [];
    const sale = find(sales, sale => sale.id === saleId);
    const isSaleDelivered = AppConstants.SALE_STATE_DELIVERED.includes(get(sale, 'state'));

    if (isSaleDelivered) {
      CustomDialog.showInfo(t('warning'), t('sales_warning_not_able_deliver_orders'));
    } else {
      CustomDialog.showWarningConfirmation(
        t('warning'),
        t('sales_warning_confirm_delete_sale'),
        () => {
          InventoryStore.deleteSale(saleId, onSuccess, onFailure);
        }
      );
    }
  },

  onChangeSale(sale, onSuccess) {
    const allAddress = get(this.state, 'selectedItem.allAddress');
    sale.shipTo = find(allAddress, address => get(address, 'id') === get(sale, 'shipToId'));
    sale.billTo = find(allAddress, address => get(address, 'id') === get(sale, 'billToId'));
    InventoryStore.changeSale(
      sale,
      onSuccess,
      this.__onFailureShowMessageError
    );
    this.clearValue();
  },

  onAddSale(sale, onSuccess, onFailure) {
    const customerAddress = get(this.state, 'customerAddress');
    sale.shipTo = find(customerAddress, address => get(address, 'id') === get(sale, 'shipToId'));
    sale.billTo = find(customerAddress, address => get(address, 'id') === get(sale, 'billToId'));
    InventoryStore.addSale(sale, onSuccess, onFailure);
    this.clearValue();
  },

  saveNewAmount() {
    let value = get(this.state, 'amountPaid');
    if(ContentUtils.isEmptyText(value)){
      value = get(this.state.selectedItem, 'totalSalePrice') ? get(this.state.selectedItem, 'totalSalePrice').replaceAll(".",",") : "0,00";
    }

    switch(NumberUtils.getCurrentCurrency().decimalSeparator){
      case '.':
          if (/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(value)) {
              InventoryStore.changeAmountPaidSO(
                {
                  id: get(this.state.selectedItem, 'id'),
                  amountPaid: value
                },
                this.onSuccess,
                this.__onFailureShowMessageError
            );
          };
          break;
      case ',':
          if (/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(value)) {
              InventoryStore.changeAmountPaidSO(
                {
                  id: get(this.state.selectedItem, 'id'),
                  amountPaid: value
                },
                this.onSuccess,
                this.__onFailureShowMessageError
            );
          };
          break;
    }
          
    this.fetchItems();
    this.clearValue();

  },

  _isPaid() {
    return get(this.state, 'selectedItem.state') === 'DELIVERED_PAID'
  },

  _onChangeAmount(sale){
    this.state.amountPaid = sale.target.value;
  },

  _onChangeComment(sale){
    this.state.selectedItem.comment = sale.target.value !== "" ? sale.target.value : "null";
  },

  _amountValidation(inputValue) {
    /* const formatter = new Intl.NumberFormat(LocaleUtils.getCurrentLocale(), {
      style: 'currency',
      currency: SessionStore.getCurrentCurrency().code,
    
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 4, // (causes 2500.99 to be printed as $2,501)
    }); */
    //console.log(SessionStore.getCurrentCurrency().code);
    //console.log(formatter.format(inputValue));
    //console.log(inputValue.replace(/\B(?=(\d{3})+(?!\d))/g,"."));
    if (ContentUtils.isEmptyText(inputValue)) {
        return '';
    }
    if (get(inputValue, 'length') > 17) {
        return t('vendor_purchase_max_price');
    }
    //console.log(/^(?:\d{1,3}(?:.\d{3})*(?:\,\d+)?|\d+(\,\d+)?)$)/.test(inputValue));
    switch(NumberUtils.getCurrentCurrency().decimalSeparator){
      case '.':
          if (!/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(inputValue)) {
              return t('notification_error_invalid_character');
          };
          break;
      case ',':
          if (!/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(inputValue)) {
              return t('notification_error_invalid_character');
          };
          break;
    }
    /*if (+inputValue.split(",")[0] > +get(this.state.selectedItem, 'totalSalePrice') !== null ? +get(this.state.selectedItem, 'totalSalePrice').split(",")[0] : 0) {
      return t('notification_error_invalid_character');
    } */

    return '';
  },

  _goToSetItems() {
    this.transitionTo(
      '/sales/:saleId/items',
      {
        saleId: get(this.state.selectedItem, 'id')
      },
      {
        customerId: get(this.state, 'selectedItem.customerId'),
        name: get(this.state, 'selectedItem.customerName'),
        code: get(this.state, 'selectedItem.code'),
        isClosed: AppConstants.SALE_STATE_DELIVERED.includes(
          get(this.state, 'selectedItem.state')
        ),
        comment: get(this.state, 'selectedItem.comment') !== "null" ? get(this.state, 'selectedItem.comment') : ""
      }
    );
  },

  _onFailureWhenSendEmailToCustomer(messageInfo) {
    if (messageInfo) {
      const haveNotEmail = messageInfo.includes(AppConstants.ERROR_CODE_SALE_WITHOUT_CONTACT_EMAIL);
      if (haveNotEmail) {
        const self = this;
        CustomDialog.showWarningConfirmation(
          t('warning'),
          t('sales_warning_no_item'),
          () => {
            self.transitionTo(
              '/customers/:customerId/contacts',
              {
                customerId: get(self.state, 'selectedItem.customerId')
              },
              {
                name: get(self.state, 'selectedItem.customerName')
              }
            );
          }
        );

      } else {
        const messageError = ContentUtils.formatMessageError(messageInfo);
        Notification.show(messageError);
      }
    }
  },

  getBreadcrumbLinks() {
    return [{ displayName: t('sales_title') }];
  },

  onSuccessSave() {
    this.fetchItems(() => {
      Notification.show(t('sales_was_created_success'), 'success');
    });
  },

  _saveComment() {
    InventoryStore.saveCommentOnlySaleOrder( get(this.state, 'selectedItem.id'), get(this.state, 'selectedItem.comment') !== "" ? get(this.state, 'selectedItem.comment') : "null");
    Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " +  get(this.state, 'selectedItem.id') + " " +  t('updated'), 'success')
  },

  _showIndicator(sale) {
    let colorFlat = 'red';
    const statePurchase = get(sale, 'state');
    const isRedState = AppConstants.PURCHASE_RED_STATE.includes(
      statePurchase
    );
    const isYellowState = AppConstants.SALE_SATES_NOTIFIED.includes(
      statePurchase
    );
    const isGreenState = AppConstants.SALE_STATE_DELIVERED.includes(
      statePurchase
    );

    if (isRedState) {
      colorFlat = 'red';
    } else if (isYellowState) {
      colorFlat = 'yellow';
    } else if (isGreenState) {
      colorFlat = 'green';
    }

    return React.createElement(FlatSphere, {bgColor: colorFlat, text: AppConstants.getSalesStateMapping(t)[statePurchase]});
  },

  _sendOrderToCustomer() {
    const self = this;
    CustomDialog.showWarningConfirmation(
      t('warning'),
      t('sales_customer_will_be_notified'),
      () => {
        const saleId = get(this.state, 'selectedItem.id');
        InventoryStore.sendOrderToCustomer(saleId,
          self._onSuccessWhenSendEmailConfirmation
          , self._onFailureWhenSendEmailToCustomer);
      });
  },

  _onSuccessWhenSendEmailConfirmation() {
    Notification.show(t('sales_order_was_sent'), 'success');
    this.fetchItems();
  },

  _onTypingFilter(name, match) {
    if (!this.state.isFetching) {
      this.setState(prevState => {
        let nextFilter = Object.assign({}, prevState.filter) || {};
        nextFilter[name] = match;
        this.fetchItemsBy(nextFilter);
        return {
          filter: nextFilter,
          isFetching: true
        };
      });
    }
  },

  clearValue() {
    this._onCancel();
  },

  clearFilters(){
    this.setState({
      selectedItem: null,
      selectedCustomer: null,
      selectedShippingTo: null,
      selectedBillingTo: null,
      isEditMode: false,
      isFetching: true,
      amountPaid: null,
      filter: Object.freeze({
        code: '',
        customerName: '',
        state: '',
        displayDateOpen: '',
        displayDeliveredDate: '',
        displayPriority: '',
        amountPaid: '',
        totalPriceWithUnit: ''
      })
  });
  this._onClickPage(0);
},

  _onCancel() {
    this.transitionTo(getCurrentUrl());
    this.setState(INITIAL_STATE);
  },

  _printReport() {
    InventoryStore.downloadReportXLS(this.state.filter, 'sales');
  },

  _onPaid() {
    InventoryStore.markPaidSale(this.state.selectedItem.id, () => {
        this._isPaid() ? Notification.show(t('vendor_purchase_removed_paid') + " " + this.state.selectedItem.id, 'success') : Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + this.state.selectedItem.code + t('vendor_purchase_marked_paid'), 'success');
        this.fetchItems();
        this.state.selectedItem = null;
    });
  },

  _onSelectBillingTo(evt, index, menuItem) {
    const selectedBillingToAddress = get(menuItem, 'itemModel.id');
    this.setState(prevState => {
      const selectedBillingTo = find(prevState.customerAddress, customerAddress => get(customerAddress, 'id') === selectedBillingToAddress);
      return {
        selectedBillingTo: selectedBillingTo ? selectedBillingTo : prevState.selectedBillingTo
      };
    });
  },

  _onSelectShippingTo(evt, index, menuItem) {
    const selectedShippingToValue = get(menuItem, 'itemModel.id');
    this.setState(prevState => {
      const selectedShippingTo = find(prevState.customerAddress, customerAddress => get(customerAddress, 'id') === selectedShippingToValue);
      return {
        selectedShippingTo: selectedShippingTo ? selectedShippingTo : prevState.selectedShippingTo
      };
    });
  },

  _onSelectCustomer(customer) {
    if (customer) {
      const self = this;
      InventoryStore.fetchCustomerAddresses(get(customer, 'id'), function (customerAddress) {
        self.setState({
          customerAddress,
          selectedCustomer: customer
        });
      });
    }
  },

  formatDate(date) {
    if (typeof date === 'string') {
      return DateUtils.toDate(date);
    } else {
      return DateUtils.toDateText(date);
    }
  },

  _commentValidation(comment) {
    if (ContentUtils.isEmptyText(comment)) {
        return '';
    }

    if (get(comment, 'length') >= 500) {
        return t('vendor_purchase_max_amount_characters');
    }

    return '';
  },

  _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
    this.setState({
      selectedItem: item,
      isEditMode: !!item,
      headerActiveFilters
    }, () => {
      // stay the position of the scroll after row select when
      // the offset Y es outside of initial viewport page.
      this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;

      this._addQueryParamWithRowSelected(item, lastRowScrollPosition);

      // select customer
      const { selectedItem, customers } = this.state;
      const customerId = get(selectedItem, 'customerId');
      const customer = find(customers, customer => get(customer, 'id') === customerId);
      this._onSelectCustomer(customer);
    });
  },

  _addQueryParamWithRowSelected(selectedItem, lastRowScrollPosition) {
    this.transitionTo(getCurrentUrl(),
      {},
      {
        selectedItemId: get(selectedItem, 'id')
      }
    );
    // Is needed to force scroll position again
    // in order to avoid jumping scroll behavior
    delay(() => {
      this.getDOMNode().querySelector(
        '.mui-body-table'
      ).scrollTop = lastRowScrollPosition;
    }, 1);
  },

  render() {
    if (!this.state.sales) {
      return React.createElement(Loading, null);
    } else {
      const messages = {
        changeSuccessMessage: t('sales_admin_change_success'),
        changeFailureMessage: t('sales_admin_change_failure'),
        deleteSuccessMessage: t('sales_admin_delete_success'),
        addSuccessMessage: t('sales_admin_add_success'),
        addFailureMessage: t('sales_admin_add_failure')
      };
      const salesPrioritiesMapping = AppConstants.getSalesStateMapping(t);
      const contextHolder = this.getContextHolderInstance();
      const { selectedItem, sales, isEditMode, customers, isFetching, selectedCustomer, selectedShippingTo, selectedBillingTo, customerAddress } = this.state;
      const hasSelectedItem = ContentUtils.isNotNullOrUndefined(selectedItem);
      const currentStateSelected = hasSelectedItem ? find(sales, sale => get(sale, 'id') === get(selectedItem, 'id')).state : get(selectedItem, 'state');

      const isCurrentItemSelectedOpenPending =
        AppConstants.SALE_STATE_OPEN_PENDING === currentStateSelected;
      const isCurrentItemDelivered =
        AppConstants.SALE_STATE_DELIVERED.includes(currentStateSelected);
      const isCurrentItemReOpenPending = AppConstants.SALE_STATE_REOPEN_PENDING === currentStateSelected;

      const safeCustomerAddress = get(selectedItem, 'allAddress') || customerAddress;
      const selectedItemShippingTo = isEditMode ? (selectedShippingTo ? selectedShippingTo : getAddress(safeCustomerAddress, selectedItem, 'shipToId')) : selectedShippingTo;
      const selectedItemBillingTo = isEditMode ? (selectedBillingTo ? selectedBillingTo : getAddress(safeCustomerAddress, selectedItem, 'billToId')) : selectedBillingTo;
      const currentCustomer = isEditMode ? getExistingCustomer(customers, selectedItem) : selectedCustomer;

      const currentSelection = selectedItem && selectedItem.displayPriority
        ? AppConstants.getSectionsMapping(t)[selectedItem.displayPriority]
        : '';

      const currentSelectedValue = currentSelection
        ? Object.assign({}, selectedItem, { displayText: currentSelection })
        : selectedItem;

      const formFieldsEl = [
        React.createElement(FormGroupTextFieldSuggested, {
          operationsHolder: contextHolder, 
          items: customers, 
          readerAttribute: "name", 
          readerAttributeValue: "id", 
          writerAttribute: "customerId", 
          customErrorNonMatch: t('sales_customer_name_required'), 
          label: t('sales_customer_name'), 
          name: t('customer'), 
          value: currentCustomer, 
          isEditMode: isEditMode, 
          isImmutable: true, 
          onEnter: this.__onEnterPress, 
          onBlur: this._onSelectCustomer}
        ),
        React.createElement(FormGroupDropdown, {
          isRelaxedText: true, 
          noInternalValidation: true, 
          items: safeCustomerAddress, 
          operationsHolder: contextHolder, 
          readerAttribute: "address", 
          writerAttribute: "billToId", 
          customReaderWriterAttribute: "id", 
          name: t('sales_bill_to'), 
          value: selectedItemBillingTo, 
          isEditMode: isEditMode, 
          onEnter: this.__onEnterPress, 
          onChange: this._onSelectBillingTo, 
          isRequired: true}
        ),
        React.createElement(FormGroupDropdown, {
          isRelaxedText: true, 
          noInternalValidation: true, 
          items: safeCustomerAddress, 
          operationsHolder: contextHolder, 
          readerAttribute: "address", 
          writerAttribute: "shipToId", 
          customReaderWriterAttribute: "id", 
          name: t('sales_ship_to'), 
          value: selectedItemShippingTo, 
          isEditMode: isEditMode, 
          isRequired: true, 
          onEnter: this.__onEnterPress, 
          onChange: this._onSelectShippingTo}
        ),
        {/* <FormGroupDropdown
          items={AppConstants.getSalesPriorities(t)}
          operationsHolder={contextHolder}
          readerAttribute="displayText"
          customReaderWriterAttribute="displayPriority"
          readerAttributeValue="displayPriority"
          writerAttribute="displayPriority"
          name={t('sales_priority')}
          value={currentSelectedValue}
          isEditMode={isEditMode}
          isRequired={false}
          onEnter={this.__onEnterPress}
        /> */},
        React.createElement(FormGroupTextfield, {
          isRelaxedText: false, 
          additionalValidation: inputValue => this._amountValidation(inputValue), 
          noInternalValidation: true, 
          operationsHolder: contextHolder, 
          // readerAttribute="amountPaid"
          name: t('sales_column_amount_paid'), 
          value: (get(selectedItem, "amountPaid", '').replace("$ ","")).toString(), 
          label: t('sales_column_amount_paid'), 
          isEditMode: isEditMode, 
          isRequired: false, 
          onChange: this._onChangeAmount}
        ),

        React.createElement(FormGroupDatePicker, {
          operationsHolder: contextHolder, 
          value: get(selectedItem, 'deliveredDate'), 
          floatingLabel: t('sales_shipping_date'), 
          writerAttribute: "deliveredDate", 
          formatDate: this.formatDate}
        ),
        React.createElement(FormGroupTextfield, {
          operationsHolder: contextHolder, 
          readerAttribute: "comment", 
          name: t('comment'), 
          value: selectedItem, 
          label: t('comment'), 
          additionalValidation: this._commentValidation, 
          isRelaxedText: false, 
          noInternalValidation: true, 
          isEditMode: isEditMode, 
          isRequired: false, 
          onChange: this._onChangeComment, 
          id: "comment"}
      )
        
      ];

      let additionalButtons = [
        {
          type: 'CHANGE',
          permission: 'VIEW_ORDER',
          el: (
            React.createElement(FormGroupButton, {
              label: 
                isCurrentItemDelivered
                  ? t('sales_view_order')
                  : t('sales_edit_order'), 
              
              icon: 
                isCurrentItemDelivered
                  ? 'visibility'
                  : 'mode_edit', 
              
              type: "icon", 
              onClick: this._goToSetItems}
            )
          )
        },{
          
          type: 'CHANGE',
          permission: 'EDIT_ORDER',
          el: (
            React.createElement(FormGroupButton, {
              label: 
                isCurrentItemDelivered
                  ? t('vendor_change_amount')
                  : t('vendor_change_amount'), 
              
              icon: 
                'mode_edit', 
              
              type: "icon", 
              onClick: this.saveNewAmount}
            )
          )
        },
        !isCurrentItemDelivered && /* {
          
          type: 'CHANGE',
          permission: 'EDIT_ORDER',
          el: (
            <FormGroupButton
              label={
                isCurrentItemDelivered
                  ? t('vendor_change_amount')
                  : t('vendor_change_amount')
              }
              icon={
                'mode_edit'
              }
              type="icon"
              onClick={this.saveNewAmount}
            />
          )
        }, */
        {
          type: 'NEW',
          permission: 'PRINT_REPORT',
          el: (
            React.createElement(FormGroupButton, {
              label: t('sales_print_report'), 
              icon: "file_download", 
              type: "icon", 
              onClick: this._printReport}
            )
          )
        },{
        type: 'NEW',
        permission: 'CLEAR_FILTER',
        el: (
            React.createElement(FormGroupButton, {
                label: t('button_label_clear_filters'), 
                icon: "clear", 
                type: "icon", 
                onClick: this.clearFilters}
            )
        )
    }
      ];

      if (
        isCurrentItemSelectedOpenPending ||
        isCurrentItemReOpenPending
      ) {
        additionalButtons.push({
          permission: 'SEND_ORDER',
          type: 'CHANGE',
          el: (
            React.createElement(FormGroupButton, {
              label: t('sales_send_order'), 
              icon: "send", 
              type: "icon", 
              onClick: this._sendOrderToCustomer}
            )
          )
        });
      }

      const totalPurchases = get(sales, '0.count') || 0;

      const state = [];
      const displayPriority = [];

      const allSalesStates = AppConstants.getSalesStateMapping(t);
      if(allSalesStates['OPEN'] !== undefined){
      Object.keys(allSalesStates).forEach((e,i)=>{
          if(i <= 3){
            displayPriority.push({id: e, state: allSalesStates[e]});
          } else {
            state.push({id: e, state: allSalesStates[e]});
          }
      })}

      additionalButtons.push({
        type: 'CHANGE',
        permission: 'SAVE_COMMENT',
        el: (
            React.createElement(FormGroupButton, {
                label: t('button_label_save_comment'), 
                icon: "save", 
                type: "icon", 
                onClick: this._saveComment}
            )
        )
    });

    additionalButtons.push(
      {
          type: 'CHANGE',
          permission: 'MARK_PAID',
          el: (isCurrentItemDelivered &&
              React.createElement(FormGroupButton, {
                  label: this._isPaid() ? t('button_revert_paid') : t('button_mark_paid'), 
                  icon: "paid", 
                  type: "icon", 
                  onClick: this._onPaid.bind()}
              )
          )
      });

      return (
        React.createElement(AdminScaffolding, {
          messages: messages, 
          moduleName: "ADMIN_SALE", 
          additionalButtons: additionalButtons, 
          title: 
            isCurrentItemDelivered
              ? `${t('sales_item_close_order')}${get(selectedItem, 'code')}`
              : isEditMode
                ? `${t('sales_item_editing_order')}${get(
                  selectedItem,
                  'code'
                )}`
                : t('sales_item_no_orders'), 
          
          contextHolder: contextHolder, 
          value: selectedItem, 
          onAddText: t('sales_create'), 
          fetchItems: this.fetchItems, 
          headerFields: formFieldsEl, 
          onAdd: this.onAddSale, 
          onChange: this.onChangeSale, 
          onCancel: this._onCancel, 
          onDelete: this.onDeleteSale, 
          addEnterKeyDown: this.__addEnterKeyDown, 
          breadcrumb: this.getBreadcrumbLinks(), 
          isDark: true
        }, 
          React.createElement(AdminScaffoldingTablePaged, {
            onRowSelection: this._onRowSelection, 
            value: selectedItem, 
            filteredColumns: [
              'code',
              'customerName',
              'state',
              'displayDateOpen',
              'displayDeliveredDate',
              /* 'displayPriority', */
              'amountPaid',
              'totalPriceWithUnit',
            ], 
            displayAttributes: [
              'code',
              'customerName',
              {
                name: 'state',
                getHTML: this._showIndicator
              },
              'displayDateOpen',
              'displayDeliveredDate',
              /* 'displayPriority', */
              'amountPaid',
              'totalPriceWithUnit'
            ], 
            columnNames: [
              t('sales_column_number'),
              t('sales_column_customer'),
              t('sales_column_status'),
              t('sales_column_created'),
              t('sales_column_shipping_date'),
              /* t('sales_column_priority'), */
              t('sales_column_amount_paid'),
              t('sales_column_total_price')
            ], 

            isLoading: isFetching, 
            maxPage: ContentUtils.getAmountPageNeeded(totalPurchases, AppConstants.MAX_ITEMS_BY_PAGES_ADMINS), 
            onClickPage: this._onClickPage, 
            currentPage: NavigationUtils.getPathParam('page'), 
            columnsFilterValue: this.state.filter, 
            onCancel: this._onCancel, 
            onTypingFilter: this._onTypingFilter, 
            sortByColumn: ['created'], 
            items: {state,displayPriority}
          }, 
            sales.map(sale => {
              sale.displayPriority = salesPrioritiesMapping[sale.priority];
              sale.displaySate = salesPrioritiesMapping[sale.status];
              return sale;
            })
          )
        )
      );
    }
  }
});

function getExistingCustomer(customers, selectedItem) {
  return find(customers, customer => get(customer, 'id') === get(selectedItem, 'customerId'));
}

function getCurrentUrl() {
  return pageUrl + NavigationUtils.getPathParam('page');
}

function getAddress(customerAddress, selectedItem, fieldId) {
  return find(customerAddress, address => get(address, 'id') === get(selectedItem, fieldId));
}

module.exports = SalesAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/SalesAdmin/SalesAdmin.jsx
 **/